export default __webpack_public_path__ + "static/media/products-briquttes-icon.4f462727.svg";